<ol class="paginator-container">
  <li (click)="navigateToPage(1)" *ngIf="isGoToFirstPageEnabled"  [class.disabled]="pageLength === 1 || value === 1">{{'Translation.First' | translate}}</li>
  <li (click)="navigateToPage(value - 1)" [class.disabled]="pageLength === 1 || value === 1">{{'Translation.Previous' | translate}}</li>
  <ng-container *ngIf="!firstSection && partStatus">
    <li (click)="navigateToPage(1)">1</li>
   <li class="disabled">...</li>
  </ng-container>
  <li
    *ngFor="let page of partArray; trackBy: trackByFn"
    [class.active]="page === pagination.value"
    (click)="navigateToPage(page)"
  >
    {{ page }}
  </li>
  <ng-container *ngIf="!lastSection">
   <li class="disabled">...</li>
   <li (click)="navigateToPage(pageLength)">{{pageLength}}</li>
  </ng-container>
  <li (click)="navigateToPage(value + 1)"  [class.disabled]="pageLength === 1 || value === pageLength">{{'Translation.Next' | translate}}</li>
  <li (click)="navigateToPage(pageLength)" *ngIf="isGoToLastPageEnabled"  [class.disabled]="pageLength === 1 || value === pageLength">{{'Translation.Last' | translate}}</li>
</ol>
